import React from 'react';
import { Input, FormFeedback, FormGroup, Label } from 'reactstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CoreExportModuleSchoolUnit, CoreImportModuleSchoolUnit, CoreImportModuleSchoolUnitExportModule } from '../../../../models/CoreModels';
import { OnChangeCallback } from '../../../../util/UtilityTypes';


interface SchoolUnitProps<TModuleSchoolUnit extends CoreExportModuleSchoolUnit | CoreImportModuleSchoolUnit> {
    disabled: boolean
    validation: string[]
    schoolUnit: TModuleSchoolUnit
    onChange: OnChangeCallback<TModuleSchoolUnit>
};

const exportModuleLinks = (exportModules: CoreImportModuleSchoolUnitExportModule[] | undefined) => {
    if (!exportModules) {
        return null;
    }
    if (exportModules.length > 0) {
        return exportModules.map(em => {
            return <span key={em.id}><Link to={`/module/${em.id}/configuration`} target="_blank">{em.title} </Link></span>;
        });
    }
    return null;
}

export const ExportSchoolUnitCheckbox = (props: SchoolUnitProps<CoreExportModuleSchoolUnit>) => {
    const { t } = useTranslation('configuration');
    if (!props.schoolUnit.title) {
        return null;
    }

    const disabled = (!props.schoolUnit.isActive && !props.schoolUnit.shouldImport) || props.disabled;

    return <>
        <FormGroup check title={props.schoolUnit.title} disabled={disabled}>
            <Label check for={props.schoolUnit.id} className="schoolUnitCheckbox">{props.schoolUnit.title}</Label>
            <Input type="checkbox"
                id={props.schoolUnit.id}
                disabled={disabled}
                checked={props.schoolUnit.shouldImport}
                onChange={() => props.onChange('exportSchoolUnits', { ...props.schoolUnit, shouldImport: !props.schoolUnit.shouldImport })}
                invalid={props.validation.some(v => v === `inactive-${props.schoolUnit.id}` || v === `references-${props.schoolUnit.id}`)}
            />
            <FormFeedback>
                {props.validation.some(v => v === `inactive-${props.schoolUnit.id}`) && t('schoolUnitConfiguration.inactiveInSource')}
            </FormFeedback>
        </FormGroup>
    </>;
}

export const ImportSchoolUnitCheckbox = (props: SchoolUnitProps<CoreImportModuleSchoolUnit>) => {
    const { t } = useTranslation('configuration');
    if (!props.schoolUnit.title) {
        return null;
    }

    const disabled = (!props.schoolUnit.isActive && !props.schoolUnit.shouldImport) || props.disabled;

    return <>
        <FormGroup check title={props.schoolUnit.title} disabled={disabled}>
            <Label check for={props.schoolUnit.id} className="schoolUnitCheckbox">{props.schoolUnit.title}</Label>
            <Input type="checkbox"
                id={props.schoolUnit.id}
                disabled={disabled}
                checked={props.schoolUnit.shouldImport}
                onChange={() => props.onChange('importSchoolUnits', { ...props.schoolUnit, shouldImport: !props.schoolUnit.shouldImport })}
                invalid={props.validation.some(v => v === `inactive-${props.schoolUnit.id}` || v === `references-${props.schoolUnit.id}`)}
            />

            <FormFeedback>
                {props.validation.some(v => v === `inactive-${props.schoolUnit.id}`) && t('schoolUnitConfiguration.inactiveInSource')}
                {props.validation.some(v => v === `references-${props.schoolUnit.id}`) && <span>{t('schoolUnitConfiguration.exportModuleWarning')}: {exportModuleLinks(props.schoolUnit.exportModules)}</span>}
            </FormFeedback>
        </FormGroup>
    </>;
}